import React, { useEffect, useState } from 'react';

import '/src/styles/index.css';
import styles from './styles.module.css';
import MailingCreate from './mailingCreate/MailingCreate';
import MailingSchedule from './mailingSchedule/MailingSchedule';
import MailingArchive from './mailingArchive/MailingArchive';
import ConnectBot from './connectBot/ConnectBot';
import adapter from '../../../../adapter';
import refreshToken from '../../../../refreshToken';
import { useNavigate } from 'react-router-dom';
import mail  from '/public/mailing.png';
import mailW  from '/public/mailing-w.png';
import sched  from '/public/sched.png';
import schedW  from '/public/sched-w.png';
import arch  from '/public/archive.png';
import archW  from '/public/archive-w.png';
import { FaEnvelopeOpenText, FaCalendarAlt ,FaArchive   } from 'react-icons/fa';

const MailingPage = ({refreshComponent}) => {

    const storedData = JSON.parse(localStorage.getItem('dashboardData'));
    const dashboardData = storedData ? storedData: null;
    const [mailingPageState, setMailingPageState] = useState('mailing-create');
    const [botsData, setBotsData] = useState([]);
    const [spamsSchaludeData, setSchaludeSpamsData] = useState([]);
    const [spamsArchivedData, setSpamsArchivedData] = useState([]);

    const [refreshData, setRefreshData] = useState(false);

    const handleRefreshSpams = (refreshSpamsData) => {
        setRefreshData(refreshSpamsData);
    }

    const renderComponent = () =>{
        switch (mailingPageState) {
            case 'mailing-create':
                return <MailingCreate botsData={botsData} refreshSpamsData={handleRefreshSpams}></MailingCreate>;
            case 'mailing-schadule':
                return <MailingSchedule botsData={botsData} spamsSchaludeData={spamsSchaludeData} refreshSpamsData={handleRefreshSpams}></MailingSchedule>;
            case 'mailing-archive':
                return <MailingArchive spamsArchivedData={spamsArchivedData} ></MailingArchive>;
            case 'connect-bot':
                return <ConnectBot></ConnectBot>;
            default:
                return <MailingCreate botsData={botsData} refreshSpamsData={handleRefreshSpams}></MailingCreate>;
        }
    };

    const handleMailingCreate = (e) => {
        setMailingPageState('mailing-create');
        
    };
    const handleMailingSchedule = (e) => {
        setMailingPageState('mailing-schadule');
        
    };
    const handleMailingArchive = (e) => {
        setMailingPageState('mailing-archive');
        
    };


    const navigate = useNavigate();
    const handleGetBots = async () => {
      
        try{
            const data = {
                user_tg_id : dashboardData.user['telegram_id'],
                access_token : dashboardData.token,
                route : 'getbotsinfo',
            };
            const response = await adapter.post('', data);
            if (response.data.result === 'success') {
                if (response.data.array.length <= 0) {
                    setMailingPageState('connect-bot')
                }else{
                    setBotsData(response.data.array);
                }

            }else if(response.data.result === 'error' && response.data.text === 'Token is expired'){
                console.log('Токен протух');
                try {
                const refreshTokenResult = await refreshToken();
                
                if (refreshTokenResult === 'logout') {
                    navigate('/', { replace: true });
                }else{
                    console.log('повторный запрос');
                    dashboardData.token = refreshTokenResult;
                    const data = {
                        user_tg_id : dashboardData.user['telegram_id'],
                        access_token : dashboardData.token,
                        route : 'getbotsinfo',
                    };
                    const response = await adapter.post('', data);
                    if (response.data.result === 'success') {
                        if (response.data.result.length <= 0) {
                            setMailingPageState('connect-bot')
                        }else{
                            setBotsData(response.data.array);
                        }
                    }
                    else {
                    console.log('повторный запрос НЕ выполнен');
                    console.log(response.data);
                    setBotsData(null);
                    }
                }
                
                } catch (error) {
                console.error(error);
                setBotsData(null);
                }
            }
            else {
                console.log('Произошла ошибка:  ' + response.data.text);
                setMailingPageState('connect-bot')
                setBotsData(null);
            }
        } catch (error){
            rollbar.error('Error during request:', error);
        }
    };
    

    const handleGetSpams = async () => {
        try{
            const data = {
                route : 'getSpams',
                user_tg_id: dashboardData.user['telegram_id'],
                access_token:dashboardData.token
            };
            const response = await adapter.post('', data);
            if (response.data.result === 'success') {

                const schadulePosts = response.data.array.filter(item => item.status === 'wait');
                const archivedPosts = response.data.array.filter(item => item.status === 'sent');

                const updatedSchedulePosts = schadulePosts.map(post => ({
                    ...post,
                    bot_id: JSON.parse(post.bot_id),
                }));
                if (updatedSchedulePosts) {
                    setSchaludeSpamsData(updatedSchedulePosts);
                }
                if (archivedPosts) {
                    setSpamsArchivedData(archivedPosts);
                }
                
            }else if(response.data.result === 'error' && response.data.text === 'Token is expired'){
                try {
                const refreshTokenResult = await refreshToken();
                
                if (refreshTokenResult === 'logout') {
                    navigate('/', { replace: true });
                }else{
                    dashboardData.token = refreshTokenResult;
                    const data = {
                        route : 'getSpams',
                        user_tg_id: dashboardData.user['telegram_id'],
                        access_token:dashboardData.token
                    };
                
                    const response = await adapter.post('', data);
                    if (response.data.result === 'success') {
                        const schadulePosts = response.data.array.filter(item => item.status === 'wait');
                        const archivedPosts = response.data.array.filter(item => item.status === 'sent');
                        
                        if (schadulePosts) {
                            setSchaludeSpamsData(schadulePosts);
                        }
                        if (archivedPosts) {
                            setSpamsArchivedData(archivedPosts);
                        }

                    }
                    else {
                        console.log(response.data);
                    }
                }
                } catch (error) {
                console.error(error);
                }
            }
            else {
            console.log('Произошла ошибка:  ' + response.data.text);
            }
        } catch (error){
            rollbar.error('Error during request:', error);
        }
    };

    

    useEffect(() => {
        if (refreshData || mailingPageState) {
            handleGetSpams();

            handleGetBots();
         
            setRefreshData(false);
        }
       
    }, [mailingPageState, refreshData]);

    useEffect(() => {
        if (refreshComponent) {
            setMailingPageState('mailing-create');
        }
        
    }, [refreshComponent]);



    return(
        <div>
            {mailingPageState !== 'connect-bot' ? (
                <>
                    <h1 className="main-title">Управление рассылками</h1>
                    <div className={styles['mailing-categories']}>
                        <button className={`${styles.btn} ${mailingPageState === 'mailing-create' ? 'main-btn' : ''}`} type="button" onClick={handleMailingCreate}>
                            <img src={mailingPageState === 'mailing-create' ? mail : mailW} alt='icon'/>
                            Создать рассылку
                        </button>
                        <button className={`${styles.btn} ${mailingPageState === 'mailing-schadule' ? 'main-btn' : ''}`}  type="button" onClick={handleMailingSchedule}>
                            <img src={mailingPageState === 'mailing-schadule' ? sched : schedW} alt='icon'/>
                            Отложенные рассылки
                        </button>
                        <button className={`${styles.btn} ${mailingPageState === 'mailing-archive' ? 'main-btn' : ''}`}  type="button" onClick={handleMailingArchive}>
                            <img src={mailingPageState === 'mailing-archive' ? arch : archW} alt='icon'/>
                            Архив рассылок
                        </button>
                    </div>
                    <>
                        {renderComponent()}
                    </>
                </>
            ): (
            <>
                {renderComponent()}
            </>
            )}
            
        
        </div>
    );
};

export default MailingPage;